var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 658,
    height: 658,
    viewBox: "0 0 658 658",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M648.046 292.753L185.092 24.364l-62.58 107.945 462.955 268.39 62.579-107.946zM652.166 440.631L189.211 172.242l-62.579 107.945 462.955 268.39 62.579-107.946z",
    fill: "#00AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M531.607 517.247L68.653 248.858 6.073 356.803l462.955 268.389 62.579-107.945z",
    fill: "#D83018"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo_svg__filter0_d_126_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.668 324.363v74.12h-8.89V241.354h8.89v74.12h80.453v-74.12h8.89v157.129h-8.89v-74.12h-80.453zm116.902 9.001h84.676c-2.074-6.741-5.593-12.594-10.557-17.557-8.742-8.742-19.261-13.113-31.559-13.113-12.298 0-22.817 4.371-31.559 13.113-5.186 5.26-8.853 11.112-11.001 17.557zm-1.667 9.001a35.453 35.453 0 00-.333 5.001c0 12.298 4.333 22.78 13.001 31.448 8.742 8.667 19.261 13.001 31.559 13.001 12.298 0 22.817-4.371 31.559-13.112a63.41 63.41 0 004.223-4.667l9.445 3.333c-1.111 1.852-3.444 4.519-7 8.001-10.52 10.594-23.262 15.891-38.227 15.891-14.816 0-27.521-5.26-38.115-15.78-10.52-10.593-15.78-23.299-15.78-38.115 0-14.965 5.26-27.707 15.78-38.226 10.594-10.52 23.299-15.78 38.115-15.78 14.965 0 27.707 5.26 38.227 15.78 9.26 9.334 13.89 20.409 13.89 33.225h-96.344zm132.015 5.112l-28.337-45.449h10.335l23.113 37.226 23.114-37.226h10.334l-28.336 45.449 31.67 51.006h-10.223l-26.559-42.672-26.558 42.672h-10.224l31.671-51.006zm156.684 51.006h-8.89v-19.669a66.592 66.592 0 01-5.557 6.556c-10.519 10.594-23.261 15.891-38.226 15.891-14.816 0-27.521-5.26-38.115-15.78-10.52-10.593-15.78-23.299-15.78-38.115 0-14.965 5.26-27.707 15.78-38.226 10.594-10.52 23.299-15.78 38.115-15.78 14.965 0 27.707 5.26 38.226 15.78a66.476 66.476 0 015.557 6.556v-13.668h8.89v96.455zm-8.89-42.449v-17.447c-1.63-8.667-5.705-16.261-12.224-22.78-8.742-8.742-19.261-13.113-31.559-13.113-12.298 0-22.817 4.371-31.559 13.113-8.668 8.742-13.001 19.261-13.001 31.559 0 12.298 4.333 22.78 13.001 31.448 8.742 8.667 19.261 13.001 31.559 13.001 12.298 0 22.817-4.371 31.559-13.112 6.519-6.52 10.594-14.076 12.224-22.669z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo_svg__filter0_d_126_5",
    x: 151.778,
    y: 241.354,
    width: 420.823,
    height: 169.907,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_126_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_126_5",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.03f97b3fd96e95fae6067fa6d077ca47.svg";
export { ForwardRef as ReactComponent };